module.exports = __webpack_public_path__ + "assets/img/monitor-add-container.3edc5e61.png";